// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2yCSw","imageUploader":"EGiftCard_imageUploader__27GDI"};